import { render, staticRenderFns } from "./CatalogListing.vue?vue&type=template&id=351fc7d0"
import script from "./CatalogListing.vue?vue&type=script&lang=js"
export * from "./CatalogListing.vue?vue&type=script&lang=js"
import style0 from "./CatalogListing.vue?vue&type=style&index=0&id=351fc7d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports